import AuthService from "./AuthService";
import ApiService from "./ApiService";

class CategoriesService extends ApiService {
    constructor(authService) {
        super();
        this._authService = authService;
        this._locale = "ru";
        this._createCategoryUrl = "/categories/create";
        this._categoriesUrl = "/categories";
        this._categoryDetailsUrl = "/categories/details";
        this._getStatusesUrl = "/categories/statuses";
        this._getMainCategoriesUrl = "/categories/main-categories";
        this._getRedirectCodesUrl = "/categories/redirect-codes";
        this._deleteUrl = "/categories/delete";
        this._deleteMultipleUrl = "/categories/delete-multiple";
        this._restoreUrl = "/categories/restore";
        this._tableDataUrl = "/categories/table-data";
        this._updateUrl = "/categories/update/";
        this._updateStatusesUrl = "/categories/update-status";
        this._updateCodesUrl = "/categories/update-code";
    }

    create(data) {
        const headers = { ...this.getBaseHeaders() };
        return this.postResource(this._createCategoryUrl, data, headers);
    }

    getCategories(params) {
        return this.postResource(
            this._categoriesUrl,
            params,
            this.getBaseHeaders()
        );
    }

    getCategoryDetails(id) {
        return this.postResource(
            this._categoryDetailsUrl,
            { id },
            this.getBaseHeaders()
        );
    }

    getStatuses() {
        return this.postResource(
            this._getStatusesUrl,
            {},
            this.getBaseHeaders()
        );
    }

    getRedirectCodes() {
        return this.postResource(
            this._getRedirectCodesUrl,
            {},
            this.getBaseHeaders()
        );
    }

    getMainCategories() {
        return this.postResource(
            this._getMainCategoriesUrl,
            {},
            this.getBaseHeaders()
        );
    }

    getTableData() {
        return this.postResource(this._tableDataUrl, {}, this.getBaseHeaders());
    }

    delete(id) {
        return this.postResource(
            this._deleteUrl,
            { id },
            this.getBaseHeaders()
        );
    }

    deleteMultiple(data) {
        return this.postResource(
            this._deleteMultipleUrl,
            data,
            this.getBaseHeaders()
        );
    }

    restore(id) {
        return this.postResource(
            this._restoreUrl,
            { id },
            this.getBaseHeaders()
        );
    }

    updateCategory(data) {
        return this.postResource(this._updateUrl, data, this.getBaseHeaders());
    }

    updateStatus(data) {
        return this.postResource(
            this._updateStatusesUrl,
            data,
            this.getBaseHeaders()
        );
    }
    updateCodes(data) {
        return this.postResource(
            this._updateCodesUrl,
            data,
            this.getBaseHeaders()
        );
    }
}

const service = new CategoriesService(AuthService);

export default service;
